import { useContext } from 'react';

import { ModalContextValue } from '../ModalContext.types';
import { ModalContext } from '../ModalContext';

export const useModal = (): ModalContextValue => {
    const context = useContext(ModalContext);

    if (context === undefined) {
        throw new Error('useModal must be used within a ModalProvider');
    }

    return context;
};
